import type { LocaleObject } from '@@/shared-components/types/Objects'

export const dataLocalesQuery = queryOptions({
  queryKey: ['data-locales'],
  queryFn: async ({ signal }): Promise<{ [key: string]: LocaleObject }> => {
    const { get } = useApi()
    const res = await get<{ [key: string]: LocaleObject }>('/enums/data-locales', {}, { signal })
    return res.data
  },
})

export const appLocalesQuery = <T = { [key: string]: LocaleObject }>({
  select,
}: {
  select?: (res: { [key: string]: LocaleObject }) => T
} = {}) =>
  queryOptions({
    queryKey: ['app-locales'],
    queryFn: async ({ signal }): Promise<{ [key: string]: LocaleObject }> => {
      const { get } = useApi()
      const res = await get<{ [key: string]: LocaleObject }>('/enums/app-locales', {}, { signal })
      return res.data
    },
    select,
  })

export const messagesQuery = (
  { locale, dataLang }: { locale: string; dataLang: string },
  query?: Ref<object> | object
) =>
  queryOptions({
    queryKey: ['messages', query, locale, dataLang],
    queryFn: async ({ signal }): Promise<{ [key: string]: { [key: string]: string } }> =>
      useCustomFetch<{ [key: string]: { [key: string]: string } }>({
        url: '/public/translations/generate',
        options: {
          headers: {
            'X-Lang': locale,
            'X-Data-Lang': dataLang,
          },
        },
        query: unref(query),
        signal,
        clientOnly: true,
      }),
  })
